export const tituloPrincipal ="Envie sua Mensagem"

export const nome = 'Nome: '
export const Email = 'Email: '
export const telefone = 'Telefone: '
export const assunto = 'Assunto: '
export const mensagem = 'Mensagem: '
export const anexarArquivo = 'Anexar Arquivo:'
export const dowloadArquivo = 'Formatos permitidos: JPG, PNG, PDF, DOC'
export const Enviarmensagem = "Enviar Mensagem"
export const btnPerguntasFrequentes = "Ver Perguntas Frequentes"
export const formasDecontato = "Outras Formas de Contato"
export const rua = "Rua Exemplo, 123 - Bairro Teste, São Paulo - SP"
export const EmailDaEmpresa = "contato@exemplo.com.br"
export const TelefoneDaEmpresa = "(99) 99999-9999"